import { render, staticRenderFns } from "./MarketplaceAbout.vue?vue&type=template&id=4fff6013&"
import script from "./MarketplaceAbout.vue?vue&type=script&lang=js&"
export * from "./MarketplaceAbout.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceAbout.vue?vue&type=style&index=0&id=4fff6013&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports